export default "__VITE_ASSET__DVsnT5Xg__"